export const projects = [
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/traveladvisor-343201.appspot.com/o/edited-min.png?alt=media&token=7dd8a515-7936-485f-ac33-5f0c39bc7eb6",
    link: "https://effulgent-trifle-096edf.netlify.app/",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/traveladvisor-343201.appspot.com/o/edited2-min.png?alt=media&token=839e2e92-9ad2-47d1-8ad2-b44de4fd79d0",
    link: "https://github.com/NicoRob92/FrontEcommerce",
  },  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/traveladvisor-343201.appspot.com/o/Screenshot%202022-03-23%20at%2020-12-19%20React%20App-min.png?alt=media&token=756664a8-4589-49b4-8f8a-53754d16a16b",
    link: "https://magical-malasada-f0dcfe.netlify.app/",
  },
];
